module.exports = __webpack_public_path__ + "21e73f3ceee3d2c18e6f22aaa7bc3fe2.svg";